
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.5 6a2.92 2.92 0 002.917-2.917A2.92 2.92 0 006.5.167a2.92 2.92 0 00-2.917 2.916A2.92 2.92 0 006.5 6zM.667 10.375c0-1.942 3.883-2.917 5.833-2.917 1.95 0 5.833.975 5.833 2.917v1.458H.667v-1.458zM6.5 9.125c-1.492 0-3.183.558-3.883 1.042h7.766c-.7-.484-2.391-1.042-3.883-1.042zm1.25-6.042c0-.691-.558-1.25-1.25-1.25s-1.25.559-1.25 1.25c0 .692.558 1.25 1.25 1.25s1.25-.558 1.25-1.25zm4.617 4.425c.966.7 1.633 1.634 1.633 2.867v1.458h3.333v-1.458c0-1.683-2.916-2.642-4.966-2.867zm2.05-4.425A2.92 2.92 0 0111.5 6c-.45 0-.867-.108-1.25-.292.525-.741.833-1.65.833-2.625 0-.975-.308-1.883-.833-2.625.383-.183.8-.291 1.25-.291a2.92 2.92 0 012.917 2.916z","fill":"#24201F"}})])
          )
        }
      }
    